import {
    apiRequest,
    acteknisList,
    acteknisActive,
    acteknisInactive
} from "../../../../../services/adapters/kepegawaian/Accompetence"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", acteknisList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", acteknisInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", acteknisActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository